import { RequestError } from './request-error';
export const isResponse = (response) => !!response?.config;
/**
 * We map the backend response messages to buckets of errors based on the
 * error type. This is used to display the correct error message and format to the user.
 */
export var ErrorClassification;
(function (ErrorClassification) {
    ErrorClassification["UNCLASSIFIED"] = "UNCLASSIFIED";
    ErrorClassification["NETWORK_SERVER_DOWN"] = "API_NETWORK_INFO_SERVER_DOWN";
    ErrorClassification["NETWORK_OFFLINE"] = "API_NETWORK_INFO_OFFLINE";
    ErrorClassification["ERR_CANCELED"] = "ERR_CANCELED";
})(ErrorClassification || (ErrorClassification = {}));
export const handleResponseErrors = (error) => {
    const errorData = handleCommonStringErrors(error);
    if (isKnownError(errorData)) {
        return getKnownErrorMsg(errorData);
    }
    return ErrorClassification.UNCLASSIFIED;
};
export const getResponseErrorMsg = (response) => {
    const { data, headers: { 'content-type': contentType }, } = response;
    if (contentType?.includes('text/html') ||
        contentType?.includes('text/plain')) {
        return data;
    }
    return handleResponseErrors(data);
};
const isValidationError = (error) => !!error.validation?.body?.message;
const isErrorWithMessage = (error) => !!error.message;
const isKnownError = (error) => error &&
    typeof error === 'object' &&
    (isValidationError(error) || !!error.message || !!error.errors);
const getKnownErrorMsg = (error) => {
    if (isValidationError(error)) {
        return error.validation.body.message;
    }
    if (isErrorWithMessage(error)) {
        return error.message;
    }
    return error.errors.join('\n');
};
export const handleCommonStringErrors = (error) => {
    const isNonStringError = typeof error === 'string' && error.startsWith('Non-string error: ');
    if (isNonStringError) {
        try {
            return JSON.parse(error.replace('Non-string error: ', ''));
        }
        catch {
            return error;
        }
    }
    return error;
};
export const parseResponseError = (error) => {
    const responseError = RequestError.fromAxiosError(error);
    // response: The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // There's also `request` and `config` which contains information about the request.
    // request: The request was made but no response was received
    // is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    if (error.code === ErrorClassification.ERR_CANCELED) {
        return responseError;
    }
    const message = isResponse(error.response)
        ? getResponseErrorMsg(error.response)
        : ErrorClassification.UNCLASSIFIED;
    responseError.setMessage(message);
    return responseError;
};
//# sourceMappingURL=error.js.map